<div mat-dialog-title>
  <div>Save Dashboard</div>
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  @if (line1) {
    <p>
      {{ line1 }}
    </p>
  }
  <form [formGroup]="changeForm">
    <span class="change-to">Dashboard Name:</span>
    <mat-form-field class="change-site-name" subscriptSizing="dynamic">
      <input type="text" matInput maxlength="50" required formControlName="newName" placeholder="New Dashboard Name" />
    </mat-form-field>
    <mat-checkbox formControlName="isDefault">
      Is Default?
    </mat-checkbox>
    @if (currentId) {
      <mat-checkbox formControlName="createNewDashboard">
        Create New Dashboard
      </mat-checkbox>
    }
  </form>
</div>
<div mat-dialog-actions>
  <button data-cy="button-cancel" mat-stroked-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button
    data-cy="button-submit"
    mat-raised-button
    color="primary"
    (click)="onSubmit()">
    Submit
  </button>
</div>
